export const experience = [
    {type:'work', place: '資拓宏宇國際股份有限公司', startTime:'2015年7月', endTime:'現在', description:'主要負責智慧交通控制系統及戶役政系統'},
    {type:'school', place: '系統開發實務專班', startTime:'2014年9月', endTime:'2015年6月', description:'資拓宏宇國際股份有限公司 與 輔仁大學數學系 合辦系統開發實務專班'},
    {type:'school', place: '輔仁大學', startTime:'2011年9月', endTime:'2015年6月', description:'法國語文學系'}
];


// WEBPACK FOOTER //
// ./src/data/ExperienceFile.js